import toyota from './toyota';

export default { toyota };
